import request from '@/api/customisedAxios';

export const getInterface = {
	get: function (requestApi, data) {
		return request({
			method: 'get',
			url: requestApi,
			headers: {
				'Content-type': 'application/json',
			},
			data: JSON.stringify(data)
		})
	},
	post: function (requestApi, data) {
		return request({
			method: 'post',
			url: requestApi,
			headers: {
				'Content-type': 'application/json',
				'Randomnumber': data && data.randomNumber,
			},
			signal: data && data['controllerSignal'],
			data: JSON.stringify(data)
		})
	},
	postForm: function (requestApi, data) {
		let formData = new FormData();
		for (let key in data) {
			formData.append(key, data[key]);
		}
		return request({
			method: 'post',
			url: requestApi,
			headers: {
				'Content-type': 'application/x-www-form-urlencoded',
				'Randomnumber': data.randomNumber,
			},
			data: formData,
		})
	},
	blobGet: function (requestApi, data) {
		return request({
			method: 'get',
			url: requestApi,
			headers: {
				'Content-type': 'application/json',
				'Randomnumber': data.randomNumber
			},
			responseType: 'blob',
			data: JSON.stringify(data)
		})
	},
	blobPost: function (requestApi, data) {
		return request({
			method: 'post',
			url: requestApi,
			headers: {
				'Content-type': 'application/json',
				'Randomnumber': data.randomNumber
			},
			responseType: 'blob',
			data: JSON.stringify(data)
		})
	},
	form: function (requestApi, data) {
		return request({
			method: 'post',
			url: requestApi,
			headers: {
				'Randomnumber': data.randomNumber,
				'Content-Type': "application/x-www-form-urlencoded;charset=UTF-8",
			},
			data: data,
		});
	},
}
